import BookingGroupService from '@/services/BookingGroupService.js'
import CustomerCreditService from '@/services/CustomerCreditService.js'
import TallyService from '@/services/TallyService.js'

export const namespaced = true

export const state = {
  // Allt relaterat till att skapa och redigera bookinggroups ligger i bookingForm-modulen eftersom booking och bookinggroup har samma formulär
  dialog: {
    show: false,
    isLoading: false,
    fetchingChunks: [],
    bookingGroupId: null, // Sätts innan bookinggroup hämtats, för att säkerställa att rätt request skriver över data i dialogen
    openTab: {
      tabIndex: 'booking-group-information',
      subTabIndex: ''
    },
    bookingGroup: null,
    charges: [],
    bookingsAccommodationSums: [],
    accommodationSums: null,
    invoices: [],
    receipts: [],
    receiptPayments: [],
    invoicePaymentApplications: [],
    emails: [],
    editingRecords: []
  },
  register: {
    // Saker relaterat till att ha en öppen bookingGroup i kassan, men inte är direkt relaterat till kassan/varukorgen i sig, det ligger i cart.js
    bookingGroup: null, // OBS: öppen bookingGroup också finns i cart.js
    bookingGroupId: null, // sätts innan bookingGroup har hämtats, därför som både bookingGroup och bookingGroupId behövs
    isFetchingBookingGroup: false,
    accommodationCharges: [],
    isFetchingAccommodationCharges: false,
    invoices: [],
    isFetchingInvoices: false,
    receipts: [],
    isFetchingReceipts: false,
    bookingsAccommodationSums: [],
    accommodationSums: null,
    isFetchingAccommodationSums: false,
    timestampLastAccommodationSums: 0,
    isFetchingTallyCharges: false,
    tallyErrorMessage: '',
    isParkingBookingGroupIds: [],
    customerCredit: 0,
    isFetchingCustomerCredit: false
  },
  isSendingConfirmationBookingGroupIds: [],
  isAwaitingEmailSavedBookingGroupIds: []
}

export const mutations = {
  //
  // DIALOG
  //
  SET_SHOW_DIALOG (state, val) {
    state.dialog.show = val
  },
  SET_DIALOG_IS_LOADING (state, val) {
    state.dialog.isLoading = val
  },
  SET_DIALOG_FETCHING_CHUNKS (state, { chunkName, isFetching }) {
    if (isFetching) {
      const i = state.dialog.fetchingChunks.findIndex(id => id === chunkName)
      if (i < 0) {
        state.dialog.fetchingChunks.push(chunkName)
      }
    } else {
      const i = state.dialog.fetchingChunks.findIndex(id => id === chunkName)
      state.dialog.fetchingChunks.splice(i, 1)
    }
  },
  SET_DIALOG_BOOKING_GROUP (state, val) {
    state.dialog.bookingGroup = val
  },
  SET_DIALOG_BOOKING_GROUP_ID (state, val) {
    state.dialog.bookingGroupId = val
  },
  SET_DIALOG_CHARGES (state, val) {
    state.dialog.charges = val
  },
  SET_DIALOG_BOOKINGS_ACCOMMODATION_SUMS (state, val) {
    state.dialog.bookingsAccommodationSums = val
  },
  SET_DIALOG_ACCOMMODATION_SUMS (state, val) {
    state.dialog.accommodationSums = val
  },
  SET_DIALOG_INVOICES (state, val) {
    state.dialog.invoices = val
  },
  SET_DIALOG_RECEIPTS (state, val) {
    state.dialog.receipts = val
  },
  SET_DIALOG_RECEIPT_PAYMENTS (state, val) {
    state.dialog.receiptPayments = val
  },
  SET_DIALOG_INVOICE_PAYMENT_APPLICATIONS (state, val) {
    state.dialog.invoicePaymentApplications = val
  },
  SET_DIALOG_EMAILS (state, val) {
    state.dialog.emails = val
  },
  SET_DIALOG_EDITING_RECORDS (state, val) {
    state.dialog.editingRecords = val
  },
  SET_DIALOG_OPEN_TAB (state, { tabIndex, subTabIndex }) {
    if (tabIndex) {
      state.dialog.openTab.tabIndex = tabIndex
    }
    if (subTabIndex) {
      state.dialog.openTab.subTabIndex = subTabIndex
    }
  },
  SET_DIALOG_BOOKING_GROUP_REMARKS (state, val) {
    if (state.dialog.bookingGroup) {
      // dialog kan ha stängts, men remarks har redan sparats i db så inga problem
      state.dialog.bookingGroup.remarks = val
    }
  },
  SET_IS_SENDING_CONFIRMATION_BOOKING_GROUP_IDS (state, payload) {
    if (payload.val) {
      const i = state.isSendingConfirmationBookingGroupIds.findIndex(id => id === payload.bookingGroupId)
      if (i < 0) {
        state.isSendingConfirmationBookingGroupIds.push(payload.bookingGroupId)
      }
    } else {
      const i = state.isSendingConfirmationBookingGroupIds.findIndex(id => id === payload.bookingGroupId)
      state.isSendingConfirmationBookingGroupIds.splice(i, 1)
    }
  },
  SET_IS_AWAITING_EMAIL_SAVED_BOOKING_GROUP_ID (state, payload) {
    if (payload.val) {
      const i = state.isAwaitingEmailSavedBookingGroupIds.findIndex(id => id === payload.bookingGroupId)
      if (i < 0) {
        state.isAwaitingEmailSavedBookingGroupIds.push(payload.bookingGroupId)
      }
    } else {
      const i = state.isAwaitingEmailSavedBookingGroupIds.findIndex(id => id === payload.bookingGroupId)
      state.isAwaitingEmailSavedBookingGroupIds.splice(i, 1)
    }
  },
  ADD_DIALOG_BOOKING_GROUP_EMAIL (state, val) {
    const index = state.dialog.emails.findIndex(email => {
      return email.id === val.id
    })
    if (index >= 0) {
      state.dialog.emails.splice(index, 1, val)
    } else {
      state.dialog.emails.push(val)
    }
  },

  //
  // REGISTER
  //
  SET_REGISTER_BOOKING_GROUP (state, val) {
    state.register.bookingGroup = val
  },
  SET_REGISTER_BOOKING_GROUP_ID (state, val) {
    state.register.bookingGroupId = val
  },
  SET_REGISTER_INVOICES (state, val) {
    state.register.invoices = val
  },
  SET_REGISTER_IS_FETCHING_INVOICES (state, val) {
    state.register.isFetchingInvoices = val
  },
  SET_REGISTER_RECEIPTS (state, val) {
    state.register.receipts = val
  },
  SET_REGISTER_IS_FETCHING_RECEIPTS (state, val) {
    state.register.isFetchingReceipts = val
  },
  SET_REGISTER_BOOKINGS_ACCOMMODATION_SUMS (state, val) {
    state.register.bookingsAccommodationSums = val
  },
  SET_REGISTER_ACCOMMODATION_SUMS (state, val) {
    state.register.accommodationSums = val
  },
  SET_REGISTER_IS_FETCHING_ACCOMMODATION_SUMS (state, val) {
    state.register.isFetchingAccommodationSums = val
  },
  SET_REGISTER_TIMESTAMP_LAST_ACCOMMODATION_SUMS (state, val) {
    state.register.timestampLastAccommodationSums = val
  },
  SET_IS_FETCHING_REGISTER_BOOKING_GROUP (state, val) {
    state.register.isFetchingBookingGroup = val
  },
  SET_IS_FETCHING_REGISTER_TALLY_CHARGES (state, val) {
    state.register.isFetchingTallyCharges = val
  },
  SET_REGISTER_TALLY_ERROR_MESSAGE (state, val) {
    state.register.tallyErrorMessage = val
  },
  SET_IS_FETCHING_REGISTER_CUSTOMER_CREDIT (state, val) {
    state.register.isFetchingCustomerCredit = val
  },
  SET_REGISTER_CUSTOMER_CREDIT (state, val) {
    state.register.customerCredit = val
  },

  SET_IS_PARKING_BOOKING_GROUP_IDS (state, { bookingGroupId, val }) {
    if (val) {
      const i = state.register.isParkingBookingGroupIds.findIndex(id => id === bookingGroupId)
      if (i < 0) {
        state.register.isParkingBookingGroupIds.push(bookingGroupId)
      }
    } else {
      const i = state.register.isParkingBookingGroupIds.findIndex(id => id === bookingGroupId)
      state.register.isParkingBookingGroupIds.splice(i, 1)
    }
  }
}

export const actions = {
  sendBookingConfirmation ({ state, commit }, { bookingGroupId }) {
    commit('SET_IS_SENDING_CONFIRMATION_BOOKING_GROUP_IDS', { bookingGroupId, val: true })
    return BookingGroupService.sendBookingConfirmation({ bookingGroupId })
      .then(({ data }) => {
        // snackbar bekräftelse från servern
        if (data.status === 'success' && state.dialog.bookingGroupId === bookingGroupId) {
          // bookinggruppen är öppen i dialogen
          commit('SET_IS_AWAITING_EMAIL_SAVED_BOOKING_GROUP_ID', { bookingGroupId, val: true })
        }
      })
      .finally(() => {
        commit('SET_IS_SENDING_CONFIRMATION_BOOKING_GROUP_IDS', { bookingGroupId, val: false })
      })
  },
  openDialogById ({ state, commit, dispatch }, { bookingGroupId, startTab, refresh = false }) {
    if (startTab) {
      if (['invoices', 'receipts', 'payments'].includes(startTab)) {
        commit('SET_DIALOG_OPEN_TAB', { tabIndex: 'invoices-receipts', subTabIndex: startTab })
      } else if (['accommodation-charges', 'other-charges'].includes(startTab)) {
        commit('SET_DIALOG_OPEN_TAB', { tabIndex: 'charges', subTabIndex: startTab })
      } else {
        commit('SET_DIALOG_OPEN_TAB', { tabIndex: startTab })
      }
    } else {
      commit('SET_DIALOG_OPEN_TAB', { tabIndex: 'booking-group-information' })
    }

    if (state.dialog.show && state.dialog.bookingGroupId === bookingGroupId && !refresh) {
      // OBS: Hämtar inte om bookinggroup om redan öppen med samma bookinggroup om inte refresh = true
      return false
    }

    commit('SET_DIALOG_BOOKING_GROUP_ID', bookingGroupId) // dialog.bookingGroupId garanterar att vi inte skriver över data i bookinggroup dialog med data tillhörande en annan bookinggroup
    dispatch('resetBookingGroupDialog')
    commit('SET_DIALOG_IS_LOADING', true)
    commit('SET_SHOW_DIALOG', true)

    return dispatch('getBookingGroupDialogContent', bookingGroupId)
      .then(() => {
        if (bookingGroupId === state.dialog.bookingGroupId) {
          commit('SET_DIALOG_IS_LOADING', false)
        }
      })
  },
  resetBookingGroupDialog ({ commit }) {
    commit('SET_DIALOG_BOOKING_GROUP', null)
    commit('SET_DIALOG_CHARGES', [])
    commit('SET_DIALOG_INVOICES', [])
    commit('SET_DIALOG_RECEIPTS', [])
    commit('SET_DIALOG_RECEIPT_PAYMENTS', [])
    commit('SET_DIALOG_INVOICE_PAYMENT_APPLICATIONS', [])
    commit('SET_DIALOG_EMAILS', [])
    commit('SET_DIALOG_EDITING_RECORDS', [])
    commit('SET_DIALOG_BOOKINGS_ACCOMMODATION_SUMS', [])
    commit('SET_DIALOG_ACCOMMODATION_SUMS', null)
  },
  getBookingGroupDialogContent ({ dispatch }, bookingGroupId) {
    return Promise.allSettled([
      dispatch('getBookingGroup', { bookingGroupId }),
      dispatch('getBookingGroupCharges', { bookingGroupId }),
      dispatch('getBookingGroupAccommodationSums', { bookingGroupId }),
      dispatch('getBookingGroupInvoices', { bookingGroupId }),
      dispatch('getBookingGroupReceipts', { bookingGroupId }),
      dispatch('getBookingGroupPayments', { bookingGroupId }),
      dispatch('getBookingGroupEmails', { bookingGroupId }),
      dispatch('getBookingGroupEditingRecords', { bookingGroupId })
    ])
  },
  getBookingGroup ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'booking-group', isFetching: true })
    }
    return BookingGroupService.getBookingGroup({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichBookingGroup(data.data.booking_group)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_BOOKING_GROUP', data.data.booking_group)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'booking-group', isFetching: false })
        }
      })
  },
  getBookingGroupCharges ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'charges', isFetching: true })
    }
    return BookingGroupService.getCharges({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichCharge(data.data.charges)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_CHARGES', data.data.charges)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'charges', isFetching: false })
        }
      })
  },
  getBookingGroupAccommodationSums ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'accommodation-sums', isFetching: true })
    }
    return BookingGroupService.getAccommodationSums({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_BOOKINGS_ACCOMMODATION_SUMS', data.data.bookings_accommodation_sums)
            commit('SET_DIALOG_ACCOMMODATION_SUMS', data.data.accommodation_sums)
          }
        }
      })
      .finally(() => {
        commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'accommodation-sums', isFetching: false })
      })
  },
  getBookingGroupInvoices ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'invoices', isFetching: true })
    }
    return BookingGroupService.getInvoices({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichInvoice(data.data.invoices)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_INVOICES', data.data.invoices)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'invoices', isFetching: false })
        }
      })
  },
  getBookingGroupReceipts ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'receipts', isFetching: true })
    }
    return BookingGroupService.getReceipts({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichReceipt(data.data.receipts)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_RECEIPTS', data.data.receipts)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'receipts', isFetching: false })
        }
      })
  },
  getBookingGroupPayments ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'payments', isFetching: true })
    }
    return BookingGroupService.getPayments({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichReceiptPayment(data.data.receipt_payments)
          window.enrich.enrichInvoicePaymentApplication(data.data.invoice_payment_applications)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_RECEIPT_PAYMENTS', data.data.receipt_payments)
            commit('SET_DIALOG_INVOICE_PAYMENT_APPLICATIONS', data.data.invoice_payment_applications)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'payments', isFetching: false })
        }
      })
  },
  getBookingGroupEmails ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'emails', isFetching: true })
    }
    return BookingGroupService.getEmails({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          window.enrich.enrichEmail(data.data.emails)
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_EMAILS', data.data.emails)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'emails', isFetching: false })
        }
      })
  },
  getBookingGroupEditingRecords ({ state, commit }, { bookingGroupId }) {
    if (bookingGroupId === state.dialog.bookingGroupId) {
      commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'editing-records', isFetching: true })
    }
    return BookingGroupService.getEditingRecords({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          if (bookingGroupId === state.dialog.bookingGroupId) {
            commit('SET_DIALOG_EDITING_RECORDS', data.data.editing_records)
          }
        }
      })
      .finally(() => {
        if (bookingGroupId === state.dialog.bookingGroupId || !state.dialog.show) {
          commit('SET_DIALOG_FETCHING_CHUNKS', { chunkName: 'editing-records', isFetching: false })
        }
      })
  },
  getRegisterData ({ commit, dispatch }, { bookingGroupId }) {
    console.log('getRegisterData bookingGroupId', bookingGroupId)
    // snarlikt det som händer i booking.js när man öppnar en booking i kassan
    // metod för att hämta data till kassan när bookingGroup är ägare till varukorgen
    commit('SET_IS_LOADING_PAGE', true, { root: true })
    commit('SET_REGISTER_BOOKING_GROUP_ID', bookingGroupId)

    Promise.allSettled([
      dispatch('getRegisterBookingGroup', { bookingGroupId }),
      dispatch('getRegisterInvoices', { bookingGroupId }),
      dispatch('getRegisterReceipts', { bookingGroupId }),
      dispatch('getRegisterAccommodationSums', { bookingGroupId }),
      dispatch('getRegisterCustomerCredit', { bookingGroupId })
    ])
      .then(() => {
        commit('SET_IS_LOADING_PAGE', false, { root: true })
      })

    dispatch('getRegisterCharges', { bookingGroupId })
    // hämta tally charges ska inte vara en del av full page loadern
    // if (rootState.workstation?.access_driver === 'tally') {
    // dispatch('getRegisterTallyCharges', { bookingGroupId })
    // }
  },
  getRegisterTallyCharges ({ commit }, { bookingGroupId }) {
    // OBS: denna används inte än, behövs först när man kan checka ut hela gruppbokningen tycker jag
    commit('SET_IS_FETCHING_REGISTER_TALLY_CHARGES', true)
    commit('posCart/SET_TALLY_CHARGES', [], { root: true })
    commit('SET_REGISTER_TALLY_ERROR_MESSAGE', '')
    return TallyService.getTallyCharges({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId) {
          window.enrich.enrichCharge(data.data.tally_charges)
          // commit('posCart/SET_TALLY_CHARGES', data.data.tally_charges, { root: true })
        } else if (data.status === 'error' && data.error_code === 'tally_error') {
          window.enrich.enrichCharge(data.data.tally_charges)
          // commit('posCart/SET_TALLY_CHARGES', data.data.tally_charges, { root: true }) // tally_charges skickas trots tally_error - med tidigare hämtade charges
          commit('SET_REGISTER_TALLY_ERROR_MESSAGE', data.error_message)
        }
      })
      .finally(() => {
        commit('SET_IS_FETCHING_REGISTER_TALLY_CHARGES', false)
      })
  },
  getRegisterBookingGroup ({ commit, dispatch }, { bookingGroupId }) {
    commit('SET_IS_FETCHING_REGISTER_BOOKING_GROUP', true)
    return BookingGroupService.getBookingGroup({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId) {
          window.enrich.enrichBookingGroup(data.data.booking_group) // berikar även customer
          commit('SET_REGISTER_BOOKING_GROUP', data.data.booking_group)
          dispatch('posCart/openBookingGroup', { bookingGroup: data.data.booking_group }, { root: true })
        }
      })
      .finally(() => {
        commit('SET_IS_FETCHING_REGISTER_BOOKING_GROUP', false)
      })
  },
  getRegisterAccommodationSums ({ state, commit }, { bookingGroupId }) {
    commit('SET_REGISTER_ACCOMMODATION_SUMS', null)
    commit('SET_REGISTER_BOOKINGS_ACCOMMODATION_SUMS', [])
    commit('SET_REGISTER_IS_FETCHING_ACCOMMODATION_SUMS', true)
    return BookingGroupService.getAccommodationSums({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success') {
          if (state.register.bookingGroupId === bookingGroupId && data.data.timestamp > state.register.timestampLastAccommodationSums) {
            // Kontrollerar att bokningen i kassan inte tagits bort / byts ut sedan request skickades, och att vi inte skriver över en response som skickades senare
            commit('SET_REGISTER_TIMESTAMP_LAST_ACCOMMODATION_SUMS', data.data.timestamp)
            commit('SET_REGISTER_ACCOMMODATION_SUMS', data.data.accommodation_sums)
            commit('SET_REGISTER_BOOKINGS_ACCOMMODATION_SUMS', data.data.bookings_accommodation_sums)
            commit('posCart/SET_ACCOMMODATION_CHARGES_AMOUNT', data.data.accommodation_sums.remaining_accommodation_amount, { root: true })
          }
        }
      })
      .finally(() => {
        commit('SET_REGISTER_IS_FETCHING_ACCOMMODATION_SUMS', false)
      })
  },
  getRegisterCustomerCredit ({ state, commit }, { bookingGroupId }) {
    commit('SET_REGISTER_CUSTOMER_CREDIT', 0)
    commit('SET_IS_FETCHING_REGISTER_CUSTOMER_CREDIT', true)
    return CustomerCreditService.getCustomerCredit({ bookingGroupId, includeTimeline: false })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId) {
          commit('SET_REGISTER_CUSTOMER_CREDIT', data.data.customer_credit)
        }
      })
      .finally(() => {
        commit('SET_IS_FETCHING_REGISTER_CUSTOMER_CREDIT', false)
      })
  },
  getRegisterReceipts ({ state, commit }, { bookingGroupId }) {
    commit('SET_REGISTER_RECEIPTS', [])
    commit('SET_REGISTER_IS_FETCHING_RECEIPTS', true)
    return BookingGroupService.getReceipts({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId) {
          window.enrich.enrichReceipt(data.data.receipts)
          commit('SET_REGISTER_RECEIPTS', data.data.receipts)
        }
      })
      .finally(() => {
        commit('SET_REGISTER_IS_FETCHING_RECEIPTS', false)
      })
  },
  getRegisterInvoices ({ state, commit }, { bookingGroupId }) {
    commit('SET_REGISTER_INVOICES', [])
    commit('SET_REGISTER_IS_FETCHING_INVOICES', true)
    return BookingGroupService.getInvoices({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId) {
          window.enrich.enrichInvoice(data.data.invoices)
          commit('SET_REGISTER_INVOICES', data.data.invoices)
        }
      })
      .finally(() => {
        commit('SET_REGISTER_IS_FETCHING_INVOICES', false)
      })
  },
  getRegisterCharges ({ state, rootState, commit, dispatch }, { bookingGroupId }) {
    commit('posCart/SET_CHARGES', [], { root: true })
    commit('posCart/BEGIN_CART_LOAD', null, { root: true })
    const requestId = rootState.posCart.cartLoadRequestId
    return BookingGroupService.getCart({ bookingGroupId })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId && rootState.posCart.cartLoadRequestId === requestId) {
          window.enrich.enrichCharge(data.data.charges)
          commit('posCart/SET_CHARGES', data.data.charges, { root: true })
          if (data.data.read_consumption) {
            commit('posCart/SET_CONSUMPTION_CHARGE_IDS', data.data.charges.map(charge => charge.id), { root: true })
            return dispatch('getRegisterConsumption', { bookingGroupId })
          }
          commit('posCart/SET_CART_LOAD_ERROR', false, { root: true })
        }
      })
      .catch(() => {})
      .finally(() => {
        if (rootState.posCart.cartLoadRequestId === requestId) {
          commit('posCart/SET_IS_LOADING_CART', false, { root: true })
        }
      })
  },
  getRegisterConsumption ({ state, rootState, commit }, { bookingGroupId }) {
    const requestId = rootState.posCart.cartLoadRequestId
    const initialChargeIds = rootState.posCart.consumptionChargeIds
    commit('posCart/SET_IS_FETCHING_ELECTRICITY', true, { root: true })
    commit('posCart/SET_IS_LOADING_CART', false, { root: true })
    return BookingGroupService.getCart({ bookingGroupId, readConsumption: true })
      .then(({ data }) => {
        if (data.status === 'success' && state.register.bookingGroupId === bookingGroupId && rootState.posCart.cartLoadRequestId === requestId) {
          window.enrich.enrichCharge(data.data.charges)
          commit('posCart/APPEND_CONSUMPTION_CHARGES', { charges: data.data.charges, initialChargeIds }, { root: true })
          commit('posCart/SET_CART_LOAD_ERROR', false, { root: true })
        }
      })
      .catch(() => {})
      .finally(() => {
        if (rootState.posCart.cartLoadRequestId === requestId) {
          commit('posCart/SET_IS_FETCHING_ELECTRICITY', false, { root: true })
        }
      })
  },
  parkBookingGroup ({ commit, dispatch }, { charges, bookingGroup }) {
    // parkera charges på en gruppbokning (kan sparas på både gruppbokningen och på dess bokningar)
    const bookingGroupId = bookingGroup.id
    commit('SET_IS_PARKING_BOOKING_GROUP_IDS', { bookingGroupId, val: true })
    return BookingGroupService.parkCart({ bookingGroupId, charges })
      .then(({ data }) => {
        if (data.status === 'success') {
          dispatch('posCart/reset', null, { root: true })
          dispatch('openDialogById', { bookingGroupId, startTab: 'other-charges' })
        }
      })
      .finally(() => {
        commit('SET_IS_PARKING_BOOKING_GROUP_IDS', { bookingGroupId, val: false })
      })
  }
}

/**
 * @type {GetterTree<unknown, RootState>}
 */
export const getters = {
  //
}
